import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { makeAPI } from "../services/api";
// import t2 from "../assets/img/banner-sliders/2.avif";
// import t3 from "../assets/img/banner-sliders/3.avif";
// import t4 from "../assets/img/banner-sliders/4.avif";
// import t5 from "../assets/img/banner-sliders/5.avif";
// import t6 from "../assets/img/banner-sliders/6.avif";
// import t7 from "../assets/img/banner-sliders/7.avif";
// import t8 from "../assets/img/banner-sliders/8.avif";
// import t9 from "../assets/img/banner-sliders/9.avif";
import t10 from "../assets/img/banner-sliders/10.avif";
import coin from "../assets/img/icons/coin.avif";
// import t4 from "../assets/img/banner-sliders/4.png";

import Tournaments from "../components/home/tournaments";
import ProductCard from "../components/store/product_card";
import SocialTaskCard from "../components/home/social_task_card";
import Newsletter from "../components/home/newsletter";
import Social from "../components/home/social";
import socialTasks from "../data/social_task.json";


function buildGameImage(game) {
  if (!game?.assets?.length) return { url: "", hasPreferred: false };

  const rectangularSizes = ["1280x720", "1280x550", "512x384", "512x512"];
  const preferredAsset = rectangularSizes
    .map((size) => game.assets.find((asset) => typeof asset === "string" && asset.includes(size)))
    .find(Boolean);
  const fallbackAsset =
    game.assets.find((asset) => typeof asset === "string" && asset.includes("512x512")) ||
    game.assets.find((asset) => typeof asset === "string") ||
    "";

  const selectedAsset = preferredAsset || fallbackAsset;

  return {
    url: selectedAsset ? `https://img.gamedistribution.com/${selectedAsset}` : "",
    hasPreferred: Boolean(preferredAsset),
  };
}

function slugifyGame(game) {
  const base = (game?.slug || game?.title_slug || game?.title || "game")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return base || "game";
}

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: inviteParamId } = useParams();
  const [products, setProducts] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [topGames, setTopGames] = useState([]);
  const [isCouponPopupOpen, setIsCouponPopupOpen] = useState(false);
  const [couponData, setSelectedCoupon] = useState();
  const swiperInstancesRef = React.useRef([]);
  const tournamentImagePath = "/images/tournament-cards/";
  const featureCards = [
    {
      eyebrow: "Instant Play",
      title: "10000+ Free Games",
      description: "Tap in and find your next obsession.",
      accent: "primary",
      icon: "fa-solid fa-gamepad",
      stat: "Zero download. Full fun.",
      cta: "Open Games",
      badge: "Live Now",
      isLive: true,
      onClick: () => navigate("/games"),
    },
    {
      eyebrow: "Creator Arena",
      title: "Game Jam",
      description: "Build wild ideas. Drop them before anyone else.",
      accent: "secondary",
      icon: "fa-solid fa-bolt",
      stat: "Fast. Competitive. Creative.",
      cta: "Join Now",
      badge: "Live Now",
      isLive: true,
      onClick: () => navigate("/gamejam"),
    },
    {
      eyebrow: "Insider Drops",
      title: "Gaming Magazine",
      description: "Fresh drops, esports reads, and creator stories.",
      accent: "tertiary",
      icon: "fa-solid fa-book-open-reader",
      stat: "Sharp reads. Clean format. Soon.",
      cta: "Stay Tuned",
      badge: "Coming Soon",
      isLive: false,
    },
  ];


  const fetchProducts = async (pageNum) => {
    if (pageNum === 1) setProducts([]);
    try {
      let payload = {
        filter_data: {},
        limit: 10,
        page: 1
      }
      const response = await makeAPI('/api/get_products', "POST", false, payload);
      if (response.products.length === 0) {

      } else {
        setProducts(prev => pageNum === 1 ? response.products : [...prev, ...response.products]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const getUserData = async () => {
    try {
      const token = localStorage.getItem("token");
      const rawUser = localStorage.getItem("user");
      if (!token || !rawUser) return;

      let localUser = null;
      try {
        localUser = JSON.parse(rawUser);
      } catch {
        return;
      }

      const payload = localUser?.email ? { email: localUser.email } : {};
      const response = await makeAPI("/api/get_user_data", "POST", true, payload);

      if (response?.status === "S" && response?.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
        window.dispatchEvent(new CustomEvent("auth:updated"));
      }
    } catch (error) {
      console.error("Home user refresh failed:", error);
    }
  };

  const fetchTournaments = async () => {
    try {
      const response = await makeAPI("/api/tournament");
      setTournaments(response?.data || []);
    } catch (error) {
      console.error("Error fetching tournaments:", error);
    }
  };

  const fetchTopGames = async () => {
    try {
      const response = await makeAPI("/api/get_game_info/catalog", "POST", false, {
        page: 1,
        limit: 30,
        filter_data: {
          search: "",
          category_slugs: [],
          tag_slugs: [],
          mobile_mode: "",
          sortby: "popular",
        },
      });

      if (response?.status === "S") {
        setTopGames(response.games || []);
      } else {
        setTopGames([]);
      }
    } catch (error) {
      console.error("Error loading top games:", error);
      setTopGames([]);
    }
  };

  const handleRedeemClick = (couponData) => {
    setSelectedCoupon(couponData);
    setIsCouponPopupOpen(true);
  };

  function SliderOnclik(url,value){
        console.log("SLIDERR CLICK",url,value);
        navigate(`/${url}`, { state: { value } });
    }

  useEffect(() => {
    document.title = "Home - CGES.CLUB";
    fetchProducts(1);
    fetchTournaments();
    fetchTopGames();
    getUserData();
  }, []);

  useEffect(() => {
    const inviteId = Number(inviteParamId);
    if (!Number.isFinite(inviteId) || inviteId <= 0) return;

    sessionStorage.setItem("invite_id", String(inviteId));

    const isLoggedIn = Boolean(localStorage.getItem("token"));
    if (!isLoggedIn && window.UIkit && typeof window.UIkit.modal === "function") {
      window.UIkit.modal("#modal-login", { container: false }).show();
    }

    window.setTimeout(() => {
      navigate("/", { replace: true });
    }, 50);
  }, [inviteParamId, navigate]);

  useEffect(() => {
    const selectors = [
      {
        container: ".js-recommend .swiper",
        options: {
          slidesPerView: 1,
          spaceBetween: 40,
          loop: true,
          watchOverflow: true,
          observeParents: true,
          observeSlideChildren: true,
          observer: true,
          speed: 800,
          autoplay: { delay: 10000 },
          navigation: {
            nextEl: ".js-recommend .swiper-button-next",
            prevEl: ".js-recommend .swiper-button-prev",
          },
          pagination: {
            el: ".js-recommend .swiper-pagination",
            type: "bullets",
            clickable: true,
          },
        },
      },
      {
        container: ".js-trending .swiper",
        options: {
          slidesPerView: 1,
          spaceBetween: 40,
          loop: true,
          watchOverflow: true,
          observeParents: true,
          observeSlideChildren: true,
          observer: true,
          speed: 800,
          autoplay: { delay: 10000 },
          navigation: {
            nextEl: ".js-trending .swiper-button-next",
            prevEl: ".js-trending .swiper-button-prev",
          },
          pagination: {
            el: ".js-trending .swiper-pagination",
            type: "bullets",
            clickable: true,
          },
        },
      },
      {
        container: ".js-popular2 .swiper",
        options: {
          slidesPerView: 1,
          spaceBetween: 25,
          loop: true,
          watchOverflow: true,
          observeParents: true,
          observeSlideChildren: true,
          observer: true,
          speed: 800,
          autoplay: { delay: 5000 },
          navigation: {
            nextEl: ".js-popular2 .swiper-button-next",
            prevEl: ".js-popular2 .swiper-button-prev",
          },
          pagination: {
            el: ".js-popular2 .swiper-pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            575: {
              slidesPerView: 1,
              spaceBetween: 25,
            },
            1199: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1599: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },
        },
      },
      {
        container: ".js-store .swiper",
        options: {
          slidesPerView: 1,
          spaceBetween: 25,
          loop: true,
          watchOverflow: true,
          observeParents: true,
          observeSlideChildren: true,
          observer: true,
          speed: 800,
          autoplay: { delay: 5000 },
          navigation: {
            nextEl: ".js-store .swiper-button-next",
            prevEl: ".js-store .swiper-button-prev",
          },
          pagination: {
            el: ".js-store .swiper-pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            575: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1199: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
            1599: {
              slidesPerView: 5,
              spaceBetween: 25,
            },
          },
        },
      },
    ];

    swiperInstancesRef.current.forEach((instance) => {
      if (instance && !instance.destroyed) {
        instance.destroy(true, true);
      }
    });
    swiperInstancesRef.current = [];

    selectors.forEach(({ container, options }) => {
      const element = document.querySelector(container);
      if (element) {
        if (element.swiper && !element.swiper.destroyed) {
          element.swiper.destroy(true, true);
        }
        swiperInstancesRef.current.push(new Swiper(container, options));
      }
    });

    return () => {
      swiperInstancesRef.current.forEach((instance) => {
        if (instance && !instance.destroyed) {
          instance.destroy(true, true);
        }
      });
      swiperInstancesRef.current = [];
    };
  }, [products.length, tournaments.length]);

  useEffect(() => {
    const syncTrendingHeight = () => {
      const recommendSwiper = document.querySelector(".js-recommend .swiper");
      const trendingRoot = document.querySelector(".js-trending");
      if (!recommendSwiper || !trendingRoot) return;

      if (window.innerWidth >= 1366) {
        const recommendHeight = Math.round(recommendSwiper.getBoundingClientRect().height);
        if (recommendHeight > 0) {
          trendingRoot.style.setProperty("--news-archive-height", `${recommendHeight}px`);
        }
      } else {
        trendingRoot.style.removeProperty("--news-archive-height");
      }
    };

    let frameId = null;
    const scheduleSync = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        syncTrendingHeight();
      });
    };

    syncTrendingHeight();
    const timer = setTimeout(syncTrendingHeight, 250);
    window.addEventListener("resize", scheduleSync);

    const recommendRoot = document.querySelector(".js-recommend");
    const pageMain = document.querySelector(".page-main");
    const sidebar = document.querySelector(".sidebar");

    let resizeObserver = null;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(() => {
        scheduleSync();
      });
      if (recommendRoot) resizeObserver.observe(recommendRoot);
      if (pageMain) resizeObserver.observe(pageMain);
    }

    let mutationObserver = null;
    if (typeof MutationObserver !== "undefined" && sidebar) {
      mutationObserver = new MutationObserver(() => {
        scheduleSync();
      });
      mutationObserver.observe(sidebar, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    return () => {
      clearTimeout(timer);
      if (frameId) window.cancelAnimationFrame(frameId);
      window.removeEventListener("resize", scheduleSync);
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
    };
  }, [products.length, tournaments.length]);

  const liveTournaments = tournaments.filter((item) => item?.tournament_status === "live");
  const featuredTournaments = liveTournaments.length > 0 ? liveTournaments : tournaments;


  return (
    <>
      <div className="uk-grid" data-uk-grid>
        <div className="uk-width-2-3@l uk-width-3-3@m uk-width-3-3@s home-hero-primary">
          <h3 className="uk-text-lead">Recommended Events</h3>
          <div className="js-recommend">
            <div className="swiper">
              <div className="swiper-wrapper">
                {/* <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t9} alt="banner" onClick={() => SliderOnclik('mvp', 8)} />

                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t8} alt="banner" onClick={() => SliderOnclik('mvp', 7)} />

                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t7} alt="banner" onClick={() => SliderOnclik('mvp', 6)} />

                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <a href="#tournaments-section"><img src={t5} alt="banner" /></a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t6} alt="banner" onClick={() => SliderOnclik('mvp', 4)} />

                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t3} alt="banner" onClick={() => SliderOnclik('mvp', 3)} />

                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="recommend-slide">
                    <div className="tour-slide__box">
                      <img src={t2} alt="banner" onClick={() => SliderOnclik('mvp', 2)} />

                    </div>
                  </div>
                </div> */}


              <div className="swiper-slide">
                <div className="recommend-slide">
                  <div className="tour-slide__box">
                   <img src={t10} alt="banner" />


                  </div>
                </div>
              </div>







              </div>
              <div className="swipper-nav">
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
              </div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div className="uk-width-1-3@l uk-width-3-3@m uk-width-3-3@s home-hero-secondary">
          <h3 className="uk-text-lead">Live Tournaments</h3>
          <div className="js-trending">
            <div className="swiper">
              <div className="swiper-wrapper">
                {featuredTournaments.length === 0 ? (
                  <div className="swiper-slide">
                    <div className="home-live-tournament-card is-empty">
                      <span className="home-live-tournament-card__pill">Updating</span>
                      <h3>No live tournaments yet</h3>
                      <p>Fresh brackets and play-now drops will show up here as soon as they go live.</p>
                    </div>
                  </div>
                ) : (
                  featuredTournaments.map((tournament, idx) => {
                    const tournamentHref = `/tournaments/${tournament.game_id}/${tournament.event_id}`;
                    const tournamentStatus = tournament?.tournament_status || "Tournament";
                    const tournamentEnds = tournament?.tournament_date?.end || "soon";
                    const tournamentPrize = tournament?.prize_pool || "0";

                    return (
                      <div className="swiper-slide" key={`${tournament?.event_id || idx}-${idx}`}>
                        <article
                          className="home-live-tournament-card"
                          onClick={() => navigate(tournamentHref)}
                        >
                          <div className="home-live-tournament-card__media">
                            <img
                              src={`${tournamentImagePath}${tournament.event_icon}`}
                              alt={tournament?.event_title || "Tournament"}
                            />
                            <div className="home-live-tournament-card__overlay"></div>
                          </div>

                          <div className="home-live-tournament-card__body">
                            <div className="home-live-tournament-card__top">
                              <span className={`home-live-tournament-card__pill ${tournament?.tournament_status === "live" ? "is-live" : "is-upcoming"}`}>
                                {tournamentStatus}
                              </span>
                            </div>

                            <div className="home-live-tournament-card__main">
                              <span className="home-live-tournament-card__eyebrow">Compete Live</span>
                              <h3>{tournament?.event_title || "Tournament"}</h3>
                              <p>Queue up, push the leaderboard, and take your shot at the pool.</p>
                            </div>

                            <div className="home-live-tournament-card__bottom">
                              <div className="home-live-tournament-card__info-grid">
                                <div className="home-live-tournament-card__info-item">
                                  <span>Ends</span>
                                  <strong>{tournamentEnds}</strong>
                                </div>
                                <div className="home-live-tournament-card__info-item home-live-tournament-card__info-item--accent">
                                  <span>Prize Pool</span>
                                  <strong style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                    <img src={coin} width="18" height="18" alt="Coin icon" />
                                    {tournamentPrize}
                                  </strong>
                                </div>
                              </div>

                              <a
                                className="home-live-tournament-card__cta"
                                href={tournamentHref}
                                onClick={(event) => event.stopPropagation()}
                              >
                                Play Now
                                <i className="fa-solid fa-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </article>
                      </div>
                    );
                  })
                )}

              </div>
              <div className="swipper-nav">
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
              </div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>


        <div className="uk-width-1-1">
          <h3 className="uk-text-lead">Explore More</h3>
          <div className="uk-grid uk-grid-small home-feature-grid" data-uk-grid>
            {featureCards.map((card) => {
              const isActive = Boolean(card.isLive && typeof card.onClick === "function");

              return (
                <div className="uk-width-1-3@l uk-width-1-2@m uk-width-1-1@s home-feature-item" key={card.title}>
                  <article
                    className={`home-feature-card home-feature-card--${card.accent} ${isActive ? "is-active" : "is-soon"}`}
                  >
                    <div className="home-feature-card__content">
                      <div className="home-feature-card__meta">
                        <div className="home-feature-card__icon">
                          <i className={card.icon}></i>
                        </div>
                        <div className="home-feature-card__copy">
                          <span className="home-feature-card__eyebrow">{card.eyebrow}</span>
                          <h3>{card.title}</h3>
                          <p>{card.description}</p>
                        </div>
                      </div>

                      <div className="home-feature-card__bottom">
                        <span className="home-feature-card__stat">{card.stat}</span>
                        <span className={`home-feature-card__badge ${isActive ? "is-live" : ""}`}>{card.badge}</span>
                      </div>

                      <button
                        type="button"
                        className={`home-feature-card__cta ${!isActive ? "is-disabled" : ""}`}
                        onClick={card.onClick}
                        disabled={!isActive}
                      >
                        {card.cta}
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </div>

        <div className="uk-width-1-1">
          <div className="home-top-games-head">
            <div>
              <h3 className="uk-text-lead">Top Liked Games</h3>
              {/* <p>Thirty crowd favorites ready to play.</p> */}
            </div>
            <button
              type="button"
              className="home-top-games-link"
              onClick={() => navigate("/games")}
            >
              View All
              <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>

          {topGames.length > 0 ? (
            <div className="home-top-games-grid">
              {topGames.map((game) => {
                const imageData = buildGameImage(game);

                return (
                  <article
                    key={game.game_id}
                    className="home-top-game-card"
                    onClick={() => navigate(`/games/${slugifyGame(game)}`)}
                  >
                    <div className={`home-top-game-card__media ${imageData.hasPreferred ? "" : "fallback"}`}>
                      {imageData.url ? (
                        <img src={imageData.url} alt={game.title} loading="lazy" />
                      ) : (
                        <div className="home-top-game-card__placeholder">
                          <i className="fa-solid fa-gamepad"></i>
                        </div>
                      )}
                    </div>

                    <div className="home-top-game-card__body">
                      <h4>{game.title}</h4>
                      <div className="home-top-game-card__meta">
                        <span>Top pick</span>
                        <span className="home-top-game-card__play">
                          Play
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="home-top-games-empty">Top liked games are loading right now.</div>
          )}
        </div>

        <Tournaments />

        


        {/* <div className="uk-width-1-1">
          <h3 className="uk-text-lead">Social Tasks</h3>
          <div className="js-popular2">
            <div className="swiper">
              <div className="swiper-wrapper">



                {socialTasks.map((task, idx) => (
                  <div className="swiper-slide" key={idx}>
                    <SocialTaskCard data={task}/>
                  </div>
                ))}

              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div> */}

        <div className="uk-width-1-1">
          <h3 className="uk-text-lead">Our Store</h3>
          <div className="js-store">
            <div className="swiper">
              <div className="swiper-wrapper">

                {products.map((product, index) => (
                  <div className="swiper-slide"  key={index}>
                  <ProductCard product_data={product} onRedeem={handleRedeemClick} />
                  </div>
                ))}
              </div>

              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>

        <div className="uk-width-1-1">
          <h3 className="uk-text-lead">Join Our Community</h3>
          <div className="uk-grid uk-grid-small home-connect-grid" data-uk-grid>
            <div className="uk-width-1-2@m uk-width-1-1@s">
              <Newsletter />
            </div>
            <div className="uk-width-1-2@m uk-width-1-1@s">
              <Social />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

